/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CareerDto } from '../models/CareerDto';
import type { CreateCareerDto } from '../models/CreateCareerDto';
import type { UpdateCareerDto } from '../models/UpdateCareerDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CareersService {
  /**
   * 경력사항 가져오기
   * @returns CareerDto
   * @throws ApiError
   */
  public static careerControllerCareer({
    resumeId,
  }: {
    resumeId: number;
  }): CancelablePromise<Array<CareerDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/resume/{resumeId}/careers',
      path: {
        resumeId: resumeId,
      },
    });
  }

  /**
   * 경력사항 생성하기
   * @returns CareerDto
   * @throws ApiError
   */
  public static careerControllerCreateCareer({
    requestBody,
  }: {
    requestBody: CreateCareerDto;
  }): CancelablePromise<CareerDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/careers',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 경력사항 수정하기
   * @returns CareerDto
   * @throws ApiError
   */
  public static careerControllerUpdateCareer({
    id,
    requestBody,
  }: {
    id: number;
    requestBody: UpdateCareerDto;
  }): CancelablePromise<CareerDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/careers/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 경력사항 삭제하기
   * @returns CareerDto
   * @throws ApiError
   */
  public static careerControllerDeleteCareer({
    id,
  }: {
    id: number;
  }): CancelablePromise<CareerDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/careers/{id}',
      path: {
        id: id,
      },
    });
  }
}
